import { render, staticRenderFns } from "./AddUserView.vue?vue&type=template&id=42ef8c21"
import script from "./AddUserView.vue?vue&type=script&lang=js"
export * from "./AddUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports